// extracted by mini-css-extract-plugin
export default {"spinnerContianer":"lT2U2mc6LALehhA6yzFQ__spinnerContianer___"};